<template>
  <div class="service-carousel">

    <div class="service-carousel__inner">
      <div ref="service-carousel-text"
           class="service-carousel__text  d-sm-none">
        <div class="service-carousel__text-list">
          <div v-for="item in slides"
               :key="item.id"
               class="service-carousel__text-item">
            <h4 v-if="item.title"
                class="service-carousel__item-subtitle  d-sm-none">{{ item.title }}</h4>
            <h3 v-if="item.subtitle"
                class="service-carousel__item-title  d-sm-none">{{ item.subtitle }}</h3>
            <p v-if="item.text"
               class="service-carousel__item-text">{{ item.text }}</p>
            <router-link-modified v-if="item.link"
                                  :to="item.link"
                                  tag="a"
                                  class="service-carousel__btn  base-btn  base-btn--blue">
              <span>{{ $tHome('More details') }}</span>
              <BaseSvg name="ico-arrow-light"
                       class="_arrow"/>
            </router-link-modified>
          </div>
        </div>
      </div>

      <div ref="service-carousel-image" class="service-carousel__image">
        <div class="service-carousel__image-list">
          <div v-for="item in slides"
               :key="item.id"
               class="service-carousel__image-item">
            <h4 v-if="item.title"
                class="service-carousel__item-subtitle  d-none  d-sm-block">{{ item.title }}</h4>
            <h3 v-if="item.subtitle"
                class="service-carousel__item-title  d-none  d-sm-block">{{ item.subtitle }}</h3>

            <picture :src="item.image"
                          :title="createTitleMixin(item.title)"
                          :alt="createAltMixin(item.title)"
                          class="service-carousel__item-img-wrap">
              <source v-if="item.image_webp"
                      :srcset="item.image_webp"
                      type="image/webp">
              <img :src="item.image"
                   :title="createTitleMixin(item.title)"
                   :alt="createAltMixin(item.title)">
            </picture>

            <p v-if="item.text"
               class="service-carousel__item-text    d-none  d-sm-block">{{ item.text }}</p>
            <router-link-modified v-if="item.link"
                                  :to="item.link"
                                  tag="a"
                                  class="service-carousel__btn  base-btn  base-btn--blue  d-none  d-sm-inline-flex">
              <span>{{ $tHome('More details') }}</span>
              <BaseSvg name="ico-arrow-light"
                       class="_arrow"/>
            </router-link-modified>
          </div>
        </div>
      </div>

      <div class="service-carousel__navigation">
        <div class="nav">
          <button ref="prev" class="service-carousel__nav  _prev  base-btn">
            <BaseSvg name="ico-arrow-light-2"/>
          </button>
          <div ref="service-carousel_pagination" class="service-carousel__pagination"></div>
          <button ref="next" class="service-carousel__nav  _next  base-btn">
            <BaseSvg name="ico-arrow-light-2"/>
          </button>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  import Swiper from 'swiper'

  export default {
    name: 'ServiceCarousel',
    props: {
      slides: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        swiperImages: null,
        swiperText: null
      }
    },
    computed: {},
    methods: {
      createSwiper() {
        this.swiperText = new Swiper(this.$refs['service-carousel-text'], {
          wrapperClass: 'service-carousel__text-list',
          slideClass: 'service-carousel__text-item',
          slidesPerView: 'auto',
          watchOverflow: true,
          roundLengths: true,
          observer: true,
          // autoHeight: true,
          observeParents: true,
          observeSlideChildren: true,
          speed: 700,
          navigation: {
            prevEl: this.$refs['prev'],
            nextEl: this.$refs['next'],
            disabledClass: '_disabled',
            hiddenClass: '_hidden',
            lockClass: '_hidden'
          },
          pagination: {
            el: this.$refs['service-carousel_pagination'],
            type: 'bullets',
            bulletClass: 'service-carousel__pagination-item',
            bulletActiveClass: '_active',
            lockClass: '_hidden',
            clickable: true
          },
        })

        this.swiperImages = new Swiper(this.$refs['service-carousel-image'], {
          wrapperClass: 'service-carousel__image-list',
          slideClass: 'service-carousel__image-item',
          slidesPerView: 'auto',
          watchOverflow: true,
          roundLengths: true,
          observer: true,
          // autoHeight: true,
          observeParents: true,
          observeSlideChildren: true,
          speed: 700,
          pagination: {
            el: this.$refs['service-carousel_pagination'],
            type: 'bullets',
            bulletClass: 'service-carousel__pagination-item',
            bulletActiveClass: '_active',
            lockClass: '_hidden',
            clickable: true
          },
        })

        this.swiperText.controller.control = this.swiperImages
        this.swiperImages.controller.control = this.swiperText

      }
    },
    mounted() {
      this.createSwiper()
    },
    beforeDestroy() {
      if (this.swiperImages) {
        this.swiperImages.destroy()
      }
      if (this.swiperText) {
        this.swiperText.destroy()
      }
    }
  }
</script>

<style>

</style>
